module.exports = __webpack_public_path__ + "static/img/2.a8f9fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs/2.png
// module id = 1zy7
// module chunks = 1